import { scheduleMembershipService } from '@libs/data-access/queries'
import { Avatar } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import moment from 'moment'
import type { FC } from 'react'

import styles from './HeaderInfo.module.css'

type Props = {
  membershipId: number
  date?: string
}

export const HeaderInfo: FC<Props> = ({ membershipId, date }) => {
  const membershipQuery =
    scheduleMembershipService.membership.useFetchScheduleMembership({
      pathParams: { membership_id: membershipId }
    })
  const formatedDate = moment(date).format('dddd DD MMMM')
  const { t } = useCommonAppTranslation()

  return (
    <div className={styles.GeneralInfo}>
      <div className={styles.UserInfo}>
        <Avatar
          size='s'
          labels={[
            membershipQuery.data?.firstname ?? '',
            membershipQuery.data?.lastname ?? ''
          ]}
        />
        <span className={styles.UserName}>
          {t('models.fullname', {
            value: {
              firstname: membershipQuery.data?.firstname ?? '',
              lastname: membershipQuery.data?.lastname ?? ''
            }
          })}
        </span>
      </div>
      <div className={styles.Date}>{formatedDate}</div>
    </div>
  )
}
